import {ObjectId} from 'bson';
import {z} from 'zod';
import {zodEnum} from '../util';

export const FieldDataTypes = [
  'boolean',
  'date',
  'dateTime',
  'multiPicklist',
  'number',
  'picklist',
  'string',
] as const;
export const FieldDataTypeSchema = zodEnum(FieldDataTypes);
export type FieldDataType = z.infer<typeof FieldDataTypeSchema>;

export const StatusSchema = z.union([
  z.literal('draft'),
  z.literal('published'),
]);
export type Status = z.infer<typeof StatusSchema>;
export const StatusLabels: Record<Status, string> = {
  draft: 'Draft',
  published: 'Published',
};

export const BaseFieldDefinitionSchema = z.object({
  id: z.instanceof(ObjectId),
  label: z.string(),
  dataType: FieldDataTypeSchema,
  timestamp: z.date(),
  status: StatusSchema,

  // overridden by subtypes
  config: z.object({}).optional(),
  type: z.string(),
});

export interface FieldMetadata {
  reasoning?: string;
}

export interface BaseFieldValue {
  customerId: ObjectId;
  accountId: ObjectId;
  fieldDefinitionId: ObjectId;

  timestamp: Date;
  value: unknown;
  metadata?: FieldMetadata;
}
